/**
 * ESCALAR LOS MACROS AL CAMBIAR LA CANTIDAD, SIN QUE EL REDONDEO SE LOS COMA (27-09).
 *
 * La hoja de montar comida escalaba los macros desde los del paso anterior, ya redondeados a
 * una décima. Con pasos pequeños el redondeo se comía cada subida: 200 ml de leche de
 * almendras (2,2 g de grasa) subidos de uno en uno hasta 450 ml seguían diciendo 2,2 g. La
 * barra enseñaba una grasa falsa y el tope de 4 g del post no saltaba nunca (lo cazó el
 * verificador del postentreno).
 *
 * Ahora cada alimento recuerda su punto de partida (`_ef_base`: los macros que cuentan y la
 * cantidad a la que corresponden) y se escala siempre desde ahí. Sigue sin rehacer la cuenta
 * desde la etiqueta: escalar lo que ya cuenta nunca inventa un cero (los anacardos).
 */
const r1 = (v) => Math.round((v || 0) * 10) / 10;

const desdeLoActual = (f) => {
    const ef = f?.macros_efectivos || {};
    return { g: Number(f?.cantidad_g ?? f?.cantidad ?? 0), P: ef.P || 0, H: ef.H || 0, G: ef.G || 0 };
};

/**
 * El punto de partida. Si los macros de ahora no son los que la base predice para esta
 * cantidad, es que alguien los corrigió después (el servidor, al calibrar el día): manda lo
 * de ahora y la base se rehace desde ahí.
 */
export const baseDeMacros = (f) => {
    const b = f?._ef_base;
    if (!b || !(b.g > 0)) return desdeLoActual(f);
    const ahora = desdeLoActual(f);
    const k = ahora.g / b.g;
    const cuadra = ['P', 'H', 'G'].every((m) => Math.abs(r1(b[m] * k) - r1(ahora[m])) <= 0.051);
    return cuadra ? b : ahora;
};

export const escalarMacros = (f, nuevaCantidad) => {
    const base = baseDeMacros(f);
    const k = base.g > 0 ? nuevaCantidad / base.g : 0;
    return {
        ...f,
        cantidad_g: nuevaCantidad,
        macros_efectivos: { P: r1(base.P * k), H: r1(base.H * k), G: r1(base.G * k) },
        _ef_base: base,
    };
};

/** Lo que aporta de un macro por gramo (o ml), sin redondeos de por medio. */
export const porGramo = (f, macro) => {
    const base = baseDeMacros(f);
    return base.g > 0 ? (base[macro] || 0) / base.g : 0;
};
